import React from 'react'
import NotificationList from '../../components/notifications/NotificationList';

const Notifications = () => {
  return <NotificationList />
}

export default Notifications
